// 13章 屋根及びとい工事 — やさしい解説
// 原文は src/spec_index.json（PDFから自動生成）。このファイルは手書きで管理する。
// SVGは currentColor を使い、ライト/ダーク両テーマに追従させる。

import type { Commentary } from "../types";

const SVG_SHITABUKI = `
<svg viewBox="0 0 660 250" role="img" aria-label="下葺きの重ね方。野地面に軒先と平行に敷き、軒先から上へ向かって張る。上下は流れ方向100ミリ以上、左右は長手方向200ミリ以上重ねる。棟や谷は300ミリ以上増張りする">
  <g fill="currentColor" opacity="0.2"><path d="M60 200 L360 60 L660 200 Z"/></g>
  <g fill="currentColor" opacity="0.4">
    <path d="M120 165 L360 90 L600 165 L600 180 L120 180 Z"/>
  </g>
  <g stroke="currentColor" stroke-width="2">
    <path d="M60 200 L360 60 L660 200" fill="none"/>
    <line x1="150" y1="150" x2="570" y2="150" opacity="0.6"/>
  </g>
  <g stroke="currentColor" stroke-width="1.8">
    <line x1="440" y1="128" x2="490" y2="128"/>
    <line x1="440" y1="120" x2="440" y2="136"/>
    <line x1="490" y1="120" x2="490" y2="136"/>
  </g>
  <g fill="currentColor" font-size="12.5" font-weight="bold" text-anchor="middle">
    <text x="360" y="45">棟：300mm以上増張り</text>
  </g>
  <g fill="currentColor" font-size="12" opacity="0.85">
    <text x="150" y="222">軒先（下）から上へ向かって張る</text>
    <text x="500" y="118">左右200mm以上</text>
    <text x="200" y="145">上下（流れ方向）100mm以上</text>
  </g>
  <g fill="currentColor" font-size="12" opacity="0.8">
    <text x="60" y="242">下葺き（ルーフィング）は屋根の防水の要。重ねの向きと寸法を守れば水は継目に入らない（13.2.3）</text>
  </g>
</svg>`;

const SVG_SEKIBAN = `
<svg viewBox="0 0 660 250" role="img" aria-label="折板葺きの構成。下地材にタイトフレームを隅肉溶接で固定し、その上に重ね形の折板を各山ごとに固定する。流れ方向には継手を設けない。けらば包みは1メートル程度の間隔で取り付ける">
  <g fill="currentColor" opacity="0.55">
    <path d="M60 150 L100 110 L140 150 L180 110 L220 150 L260 110 L300 150 L340 110 L380 150 L420 110 L460 150 L500 110 L540 150 L580 110 L620 150 L620 165 L60 165 Z"/>
  </g>
  <g fill="currentColor" opacity="0.3"><rect x="60" y="180" width="560" height="20"/></g>
  <g fill="none" stroke="currentColor" stroke-width="2">
    <path d="M120 200 L120 168 L200 168 L200 200"/>
  </g>
  <g fill="currentColor" font-size="12.5">
    <text x="60" y="45" font-weight="bold">折板葺き（工場・倉庫等の屋根）</text>
    <text x="220" y="192" opacity="0.85">タイトフレーム（隅肉溶接で下地に固定）</text>
    <text x="420" y="130" opacity="0.85">重ね形折板</text>
  </g>
  <g fill="currentColor" font-size="12" opacity="0.8">
    <text x="60" y="225">・流れ方向に継手を設けない（漏水防止）　・各山ごとにタイトフレームに固定</text>
    <text x="60" y="245">・溶接後はスラグ除去＋錆止め塗料（Az種）　・けらば包みは1ｍ程度間隔、継手重ね60mm以上＋シール</text>
  </g>
</svg>`;

const SVG_KAWARA = `
<svg viewBox="0 0 660 250" role="img" aria-label="粘土瓦葺きの構成。野地板に下葺きを張り、瓦桟木を取り付けて桟瓦を引っ掛ける。瓦は緊結用釘やねじで留め、棟は棟補強用心材に冠瓦を固定する。緊結用釘は野地板厚の半分以上に達する長さ">
  <g fill="currentColor" opacity="0.2"><path d="M80 200 L340 70 L600 200 Z"/></g>
  <g fill="none" stroke="currentColor" stroke-width="2">
    <path d="M120 175 L340 65 L560 175" />
  </g>
  <g fill="currentColor" opacity="0.5">
    <path d="M160 170 q20 -12 40 0 q20 -12 40 0 q20 -12 40 0" stroke="currentColor" stroke-width="8" fill="none"/>
  </g>
  <g stroke="currentColor" stroke-width="7" stroke-linecap="round" opacity="0.5">
    <path d="M180 160 q20 -10 40 0 q20 -10 40 0 q20 -10 40 0 q20 -10 40 0"/>
  </g>
  <g fill="currentColor">
    <circle cx="340" cy="70" r="7"/>
  </g>
  <g fill="currentColor" font-size="12.5">
    <text x="340" y="52" text-anchor="middle" font-weight="bold">棟（冠瓦＋棟補強用心材）</text>
    <text x="380" y="120" opacity="0.85">桟瓦（瓦桟木に引っ掛け＋釘・ねじで緊結）</text>
  </g>
  <g fill="currentColor" font-size="12" opacity="0.8">
    <text x="60" y="228">緊結用釘・ねじは先端が野地板厚の1/2以上に達する長さ。緊結線・棟補強金物はステンレス等（13.4）</text>
  </g>
</svg>`;

const SVG_TOI = `
<svg viewBox="0 0 660 250" role="img" aria-label="といの受金物の取付け間隔。表面処理鋼板や硬質塩化ビニル雨どいのたてどいは1.2メートル以下、軒どいは1.0メートル以下。鋼管たてどいは2メートル程度。多雪地域の軒どいは0.5メートル以下">
  <g stroke="currentColor" stroke-width="6" stroke-linecap="round">
    <line x1="120" y1="40" x2="120" y2="210"/>
  </g>
  <g fill="none" stroke="currentColor" stroke-width="4">
    <path d="M60 60 Q60 90 100 90 L560 90 Q600 90 600 60" opacity="0.6"/>
  </g>
  <g fill="currentColor">
    <circle cx="120" cy="70" r="6"/><circle cx="120" cy="130" r="6"/><circle cx="120" cy="190" r="6"/>
    <circle cx="200" cy="88" r="5"/><circle cx="320" cy="88" r="5"/><circle cx="440" cy="88" r="5"/><circle cx="560" cy="88" r="5"/>
  </g>
  <g stroke="currentColor" stroke-width="1.5">
    <line x1="140" y1="70" x2="140" y2="130"/>
    <line x1="200" y1="105" x2="320" y2="105"/>
  </g>
  <g fill="currentColor" font-size="12.5">
    <text x="150" y="105" font-weight="bold">たてどい</text>
    <text x="150" y="123" opacity="0.85">1.2ｍ以下</text>
    <text x="215" y="122" font-weight="bold">軒どい 1.0ｍ以下</text>
    <text x="380" y="55" opacity="0.85">軒どい（横に流す）</text>
    <text x="30" y="230" opacity="0.85">たてどい（縦に落とす）</text>
  </g>
  <g fill="currentColor" font-size="12" opacity="0.8">
    <text x="330" y="180">鋼管たてどいは2ｍ程度。</text>
    <text x="330" y="200">多雪地域の軒どいは0.5ｍ以下</text>
    <text x="330" y="220" opacity="0.8">（雪の重みに耐えるため間隔を詰める）</text>
  </g>
</svg>`;

const ch13: Record<string, Commentary> = {
  "13.1.1": {
    plainSummary:
      "この章は長尺金属板葺・折板葺・粘土瓦葺・とい工事に適用する。1章とセットで適用する。",
    why: "屋根は建物を雨から守る最前線です。金属板・折板・瓦という3つの葺き方と、雨水を集めて流すといが対象。どれも「漏水させない」ための重ね方・留め方・水勾配が命です。",
  },

  "13.1.2": {
    plainSummary:
      "ゴールは3つ。①所定の材料 ②所定の形状・寸法で所定の位置 ③取合い部を含め漏水がなく、屋根材は所定の耐風圧性を持ち有害な振動がないこと。",
    why: "屋根は「漏水がない」だけでなく「耐風圧性」も要求されます。台風で屋根材が飛ぶ事故を防ぐため、留付けの強度が重要です。",
  },

  "13.1.3": {
    plainSummary:
      "降雨・降雪が予想される場合、強風の場合、下地の乾燥が不十分な場合等は施工しない。下葺材の施工は気温が著しく低下した場合も行わない。",
    points: [
      "屋根は天候との勝負。天気予報で工程を組む",
      "下葺材は寒すぎると粘着・密着が効かない",
    ],
  },

  "13.2.1": {
    plainSummary:
      "この節は長尺金属板による立て平葺・心木なし瓦棒葺・横葺等の屋根葺形式に適用する。",
    glossary: [
      {
        term: "長尺金属板葺",
        meaning:
          "長い金属板（ガルバリウム鋼板等）で葺く屋根。軽く緩勾配にも使え、継目のはぜで防水する。",
      },
    ],
  },

  "13.2.2": {
    plainSummary:
      "長尺金属板は特記がなければJIS G 3322（塗装溶融55%アルミニウム−亜鉛合金めっき鋼板＝ガルバリウム）。留付け部材は亜鉛めっき鋼製またはステンレス。下葺材はアスファルトルーフィング940または改質アスファルトルーフィング下葺材（釘が打てない下地は粘着層付タイプ）。",
    glossary: [
      {
        term: "ガルバリウム鋼板",
        meaning:
          "アルミニウムと亜鉛の合金めっき鋼板。耐食性が高く、金属屋根・外壁の主流材料。",
      },
      {
        term: "下葺材（ルーフィング）",
        meaning:
          "屋根材の下に敷く防水シート。屋根材を抜けた雨水を最終的に止める二次防水。",
      },
    ],
  },

  "13.2.3": {
    plainSummary:
      "屋根葺形式・風圧力対応工法は特記。下葺は軒先から上へ張り、上下（流れ方向）100mm以上・左右（長手方向）200mm以上重ねる。留付けは重ね部300mm程度。棟は250mm以上折掛け後に300mm以上増張り、谷は300mm以上先張り。金属板の小はぜ掛けの掛かり・折返しは15mm程度。棟は棟包み納め、軒先は唐草へのつかみ込み納め、壁取合いは雨押え納め（立上り120mm程度）。",
    why: "金属屋根の防水は「下葺の重ね」と「はぜ」の2段構えです。下葺は瓦と同じで下から上へ、水下側が下になるよう重ねれば水は入りません。棟・谷・壁際は水が集まる弱点なので増張りで補強します。はぜ（金属板の折り返して噛み合わせる継目）が金属屋根の防水の主役です。",
    points: [
      "下葺の重ね：流れ方向100mm・長手方向200mm以上、軒先から上へ",
      "棟・谷・壁際は増張りで補強（水が集まる弱点）",
      "壁取合いは雨押え納め（立上り120mm程度）",
    ],
    glossary: [
      {
        term: "はぜ",
        meaning:
          "金属板の端どうしを折り返して噛み合わせた継目。防水と固定を兼ねる。",
      },
      {
        term: "唐草（からくさ）",
        meaning: "軒先に取り付ける水切り金物。葺板の先端をつかみ込む。",
      },
      {
        term: "けらば",
        meaning: "切妻屋根の妻側（棟と直角方向）の端部。",
      },
    ],
    diagrams: [
      {
        svg: SVG_SHITABUKI,
        caption: "下葺きの重ね方（13.2.3）",
      },
    ],
  },

  "13.3.1": {
    plainSummary:
      "この節は鋼板製屋根用折板を使用した屋根に適用する。",
    glossary: [
      {
        term: "折板（せっぱん）",
        meaning:
          "山と谷が交互になるよう折り曲げた鋼板の屋根材。強度が高く大スパンを飛ばせるため、工場・倉庫・体育館に使う。",
      },
    ],
  },

  "13.3.2": {
    plainSummary:
      "折板はJIS A 6514により形式・山高・山ピッチ・耐力・厚さは特記（材料は特記がなければ鋼板製）。タイトフレームは溶融亜鉛めっき鋼板。パッキンはブチルゴム製等（厚さ5mm以上）。断熱材張りは特記。",
    glossary: [
      {
        term: "タイトフレーム",
        meaning:
          "折板の谷の形に合わせた受け金具。下地（梁）に溶接し、これに折板を固定する。",
      },
    ],
  },

  "13.3.3": {
    plainSummary:
      "風圧力・耐雪性能対応工法は特記。折板の流れ方向には継手を設けない（やむを得ない場合は協議）。タイトフレームと下地材の接合は隅肉溶接（溶接後スラグ除去＋Az種錆止め塗料）。重ね形折板は各山ごとにタイトフレームに固定し、流れ方向の重ね部のボルト間隔600mm程度。けらば包みは1ｍ程度間隔で取付け、継手重ね60mm以上＋内部シーリング。",
    why: "折板屋根の防水の要は「流れ方向に継手を作らない」こと。継手があると必ずそこから漏るため、軒から棟まで1枚もので葺きます。各山ごとにタイトフレームに固定するのは、強風で折板が飛ばないための耐風圧対策です。",
    points: [
      "流れ方向に継手を設けない（1枚もので葺く）",
      "各山ごとにタイトフレームに固定",
      "タイトフレーム溶接後はスラグ除去＋錆止め（Az種）",
    ],
    diagrams: [
      {
        svg: SVG_SEKIBAN,
        caption: "折板葺きの構成（13.3.3）",
      },
    ],
  },

  "13.4.1": {
    plainSummary: "この節は粘土瓦を使用した屋根に適用する。",
  },

  "13.4.2": {
    plainSummary:
      "粘土瓦はJIS A 5208により製法・形状・寸法・産地等は特記。瓦桟木は特記がなければ杉（幅21×高さ15mm以上、防腐処理）。瓦緊結用釘・ねじはステンレス製で振動で抜けない形状。緊結線は被覆銅線径1.0mm以上またはステンレス径0.9mm以上。棟補強用金物はステンレスまたは溶融亜鉛めっき鋼。下葺材は金属板葺と同じ。",
    why: "近年の瓦屋根は「全数緊結」が基本です。過去の地震で瓦の落下・ずれが多発したため、釘・ねじ・緊結線でしっかり留めることが強く求められるようになりました。金物がステンレス中心なのは、屋根という過酷な環境で錆びないためです。",
    glossary: [
      {
        term: "瓦桟木（かわらさんぎ）",
        meaning:
          "野地板に横方向に取り付ける桟。瓦の裏の爪を引っ掛けて固定する。",
      },
      {
        term: "冠瓦（かんむりがわら）",
        meaning: "棟の頂部に被せる瓦。",
      },
    ],
  },

  "13.4.3": {
    plainSummary:
      "風圧力・地震力対応の瓦緊結方法は特記。瓦緊結用釘・ねじは先端が野地板厚の1/2以上に達する長さまたは裏面まで貫通する長さ。下葺は金属板葺（13.2.3）による。瓦桟木の位置は軒瓦の出寸法等で定める。棟は棟補強用心材取付け金物を1ｍ以内間隔で留め、心材に冠瓦をパッキン付きステンレスねじで固定、のし積み棟はのし瓦を緊結線で互いに緊結する。",
    why: "瓦の緊結は「釘が野地板の厚みの半分以上効いている」ことが条件。これで地震・台風でも瓦がずれ落ちません。棟（屋根の頂部）は最も崩れやすい部分なので、棟補強用心材と金物でがっちり固めます。従来の土だけで積む工法から、金物で緊結する工法へ変わってきた経緯を知っておきましょう。",
    points: [
      "緊結用釘・ねじは野地板厚の1/2以上に達する長さ",
      "棟は棟補強用心材＋金物で緊結（土のせだけにしない）",
    ],
    diagrams: [
      {
        svg: SVG_KAWARA,
        caption: "粘土瓦葺きの構成（13.4）",
      },
    ],
  },

  "13.5.1": {
    plainSummary: "この節は雨水を排水するといに適用する。",
    glossary: [
      {
        term: "とい（樋）",
        meaning:
          "屋根の雨水を集めて地上や排水設備へ導く部材。横に流す軒どい、縦に落とすたてどい、屋上排水のルーフドレン等がある。",
      },
    ],
  },

  "13.5.2": {
    plainSummary:
      "といの材種は表13.5.1により特記（配管用鋼管・硬質ポリ塩化ビニル管・硬質塩化ビニル雨どい・表面処理鋼板・ステンレス鋼板・ルーフドレン等）。とい受金物・足金物の取付け間隔は特記がなければ表13.5.2（表面処理鋼板・塩ビ雨どいのたてどい1.2ｍ以下、軒どい1.0ｍ以下、鋼管たてどい2ｍ程度）。多雪地域の軒どいは0.5ｍ以下。防露材は特記。",
    why: "といの受金物間隔は、材料の強さと雪の荷重で決まります。多雪地域の軒どいを0.5ｍ以下に詰めるのは、積もった雪の重みでといが垂れ下がる・外れるのを防ぐためです。屋内のたてどいは結露するので防露巻きが必要です。",
    points: [
      "たてどい1.2ｍ以下・軒どい1.0ｍ以下（表面処理鋼板・塩ビ）",
      "多雪地域の軒どいは0.5ｍ以下",
    ],
    glossary: [
      {
        term: "ルーフドレン",
        meaning: "陸屋根やバルコニーの排水口。防水層と一体で納める。",
      },
    ],
    diagrams: [
      {
        svg: SVG_TOI,
        caption: "といの受金物と取付け間隔（13.5.2）",
      },
    ],
  },

  "13.5.3": {
    plainSummary:
      "鋼管製といは排水管継手（径80mm超はやむを得ない場合溶接継手）で、ねじ切り部・溶接箇所にBz種錆止め塗料。防火区画貫通部はとい周囲にモルタル・ロックウール充填。防露巻きは表13.5.4により施工箇所に応じて行う。塩ビ管といは冷間接合（接着剤固定）。とい受金物のたてどい受は輪鉄を丁番造りとし、コンクリート下地は足金物を深さ60mm程度埋込み。ルーフドレンはコンクリート打込みで床面より下げた位置。横走り管が長い・曲がりが多い箇所は掃除口を設ける。",
    why: "といの施工の勘所は「詰まり」と「結露」への対応です。掃除口は将来の詰まり除去のため。防露巻きは屋内のといが結露して天井を濡らすのを防ぎます。ルーフドレンを床面より下げるのは、水がスムーズに流れ込むようにするためです。",
    points: [
      "防火区画貫通部はモルタル・ロックウール充填",
      "ルーフドレンは床面より下げて水はけよく",
      "詰まりやすい箇所には掃除口",
    ],
  },
};

export default ch13;
